var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardTodaysAppointments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 16,
    fill: "#FAEFF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 31.3332H22M39.3333 20.6665V25.9998M28.6667 20.6665V25.9998M28.4 47.3332H39.6C41.8402 47.3332 42.9603 47.3332 43.816 46.8972C44.5686 46.5137 45.1805 45.9018 45.564 45.1491C46 44.2935 46 43.1734 46 40.9332V29.7332C46 27.493 46 26.3729 45.564 25.5172C45.1805 24.7646 44.5686 24.1526 43.816 23.7691C42.9603 23.3332 41.8402 23.3332 39.6 23.3332H28.4C26.1598 23.3332 25.0397 23.3332 24.184 23.7691C23.4314 24.1526 22.8195 24.7646 22.436 25.5172C22 26.3729 22 27.493 22 29.7332V40.9332C22 43.1734 22 44.2935 22.436 45.1491C22.8195 45.9018 23.4314 46.5137 24.184 46.8972C25.0397 47.3332 26.1598 47.3332 28.4 47.3332Z",
    stroke: "#C63083",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTodaysAppointments);
export default __webpack_public_path__ + "static/media/card-todays-appointments.1b329cf1002040456616b80b64362c66.svg";
export { ForwardRef as ReactComponent };